import React from "react";
import { useTranslation } from "react-i18next";
import { fieldRules } from "../methods";
import Form from "../index";
import ColorPicker from "../../ColorPicker";

export const FORM_ITEM_COLOR_PICKER = "form-color-picker";

const FormItemColorPicker = (props) => {
  const { name, label, required, placeholder, rules = [], fieldProps = {}, ...rest } = props;
  const { t } = useTranslation();

  return (
    <Form.Item
      name={name}
      label={t(label)}
      rules={fieldRules(
        {
          required: required
            ? {
                message: t("container.form_errors.required")
              }
            : false,
          max: {
            value: 25,
            message: t("container.form_errors.maxLength", { value: 25 })
          }
        },
        rules
      )}
      {...rest}
    >
      <ColorPicker placeholder={placeholder} {...fieldProps} />
    </Form.Item>
  );
};

export default FormItemColorPicker;
